import { Table } from "@mantine/core";
import { TableNoResults } from "../../../../components/TableNoResults/TableNoResults";

export default function DynamicTable({ columns, rows }) {
  const normalizedColumns = columns.map((col) =>
    typeof col === "string" ? { key: col, label: col } : col,
  );

  const normalizedRows = () =>
    rows?.map((row, i) => (
      <Table.Tr key={i}>
        {normalizedColumns.map((col) => (
          <Table.Td key={col.key}>
            {col.render
              ? col.render(row)
              : (row.data?.[col.key] ?? row[col.key])}
          </Table.Td>
        ))}
      </Table.Tr>
    ));

  return (
    <div className="scroll-table-container" style={{ maxHeight: 250 }}>
      <Table withTableBorder stickyHeader horizontalSpacing="md">
        <Table.Thead>
          <Table.Tr>
            {normalizedColumns.map((col) => (
              <Table.Th key={col.key}>{col.label}</Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {normalizedRows().length > 0 ? (
            normalizedRows()
          ) : (
            <TableNoResults colSpan={columns.length} />
          )}
        </Table.Tbody>
      </Table>
    </div>
  );
}
